import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiSelectAutoComplete, MuiButton } from '../../../../../components'
import forumService from '../../../../../services/forum.service'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray, trimData } from '../../../../../util'
import { OuterWrapper, Error, Message } from './style'

const Add = ({ onChange }) => {
  const { company } = useGlobalStore()
  const strAll = 'All'
  const initialFormObj = {
    keywordSelect: strAll,
    notesSelect: strAll,
    typeSelect: strAll
  }

  const form = useRef()
  // const [formSectionData, setFormSectionData] = useState(defaultDataFunc())
  const [formData, setFormData] = useState(initialFormObj)
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [formSelectData, setFormSelectData] = useState({
    keyword: [],
    notes: [],
    type: [],
    subType: []
  })

  const onKeywordChange = async (value) => {
    onChangeHandler('keywordSelect', value)
    setFormSelectData({ ...formSelectData, notes: [], type: [] })

    const payload = { organizationId: company?.OrganizationId, keywordValue: value }
    const typesApi = await forumService.getOrganizationAggregationSubKeywordLevel1ForKeywordApi(payload)
    const subKeywordLevel1Array = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    subKeywordLevel1Array.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })
    subKeywordLevel1Array.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

    setFormSelectData({ ...formSelectData, notes: subKeywordLevel1Array })
  }

  const onSubKeywordLevel1Change = async (value) => {
    onChangeHandler('notesSelect', value)
    setFormSelectData({ ...formSelectData, type: [] })

    const payload = { organizationId: company?.OrganizationId, keywordValue: formData.keywordSelect, subKeywordLevel1Value: value }
    const typesApi = await forumService.getOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Api(payload)
    const subKeywordLevel2Array = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    subKeywordLevel2Array.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })
    subKeywordLevel2Array.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })
    setFormSelectData({ ...formSelectData, type: subKeywordLevel2Array })
  }

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    if (key === 'keywordSelect') {
      obj.keywordInput = null
    } else if (key === 'notesSelect') {
      obj.notesInput = null
    } else if (key === 'typeSelect') {
      obj.typeInput = null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()

    const payload = { organizationId: company?.OrganizationId, keywordValue: formData.keywordSelect, subKeywordLevel1Value: formData.notesSelect, subKeywordLevel2Value: formData.typeSelect }
    const response = await keywordManagement.getOrganizationAggregationSubKeywordDetailsCountApi(payload)

    onChange(getObjectAsArray(response, 'adv'))
    setFormSuccess('Done')
  }

  const onload = async () => {
    try {
      const payload = { organizationId: company?.OrganizationId }

      const keywordApi = await keywordManagement.getOrganizationAggregationKeywordsApi(payload)
      const keywordArray = getObjectAsArray(keywordApi, 'adv').map(d => ({ label: d.KeywordValue, value: d.KeywordValue, valKeywordValue: d.KeywordValue, valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm, checked: false }))
      keywordArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })
      keywordArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const notesApi = await keywordManagement.getOrganizationAggregationSubKeywordDetailsApi(payload)
      const notesArray = getObjectAsArray(notesApi, 'adv').filter(f => f.SubKeywordLevel1Value !== '').map(d => ({ label: d.SubKeywordLevel1Value, value: d.SubKeywordLevel1Value, checked: false }))
      notesArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })
      notesArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const typeArray = getObjectAsArray(notesApi, 'adv').filter(f => f.SubKeywordLevel2Value !== '').map(d => ({ label: d.SubKeywordLevel2Value, value: d.SubKeywordLevel1Value, checked: false }))
      typeArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })
      typeArray.unshift({ label: strAll, value: strAll, valKeywordValue: strAll, valKeywordId: strAll, valKeywordSearchTerm: strAll })

      const payloadData = { organizationId: company?.OrganizationId, keywordValue: 'All', subKeywordLevel1Value: 'All', subKeywordLevel2Value: 'All' }
      const response = await keywordManagement.getOrganizationAggregationSubKeywordDetailsCountApi(payloadData)
      onChange(getObjectAsArray(response, 'adv'))

      setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: notesArray, type: typeArray }))
      setFormError('')
      setFormSuccess('')
      setFormData(initialFormObj)
    } catch (error) {
      consoleLog('error = ', error)
    }
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <MuiSelectAutoComplete
              data={formSelectData.keyword}
              name='keyword'
              placeholder='Keyword'
              label='Keyword'
              // onChange={(e) => onChangeHandler('keywordSelect', e.target.value)}
              onChange={(e) => onKeywordChange(e.target.value)}
              variant='standard'
              value={formData.keywordSelect}
            />
          </Grid>
          <Grid item xs={4}>
            {formSelectData?.notes?.length > 0 && <MuiSelectAutoComplete
              data={formSelectData.notes}
              name='notes'
              placeholder='Sub Keyword Level 1'
              label='Sub Keyword Level 1'
              // onChange={(e) => onChangeHandler('notesSelect', e.target.value)}
              onChange={(e) => onSubKeywordLevel1Change(e.target.value)}
              variant='standard'
              value={formData.notesSelect || ''}
            />}
          </Grid>
          <Grid item xs={4}>
            {formSelectData?.type?.length > 0 && <MuiSelectAutoComplete
              data={formSelectData.type}
              name='type'
              placeholder='Sub Keyword Level 2'
              label='Sub Keyword Level 2'
              onChange={(e) => onChangeHandler('typeSelect', e.target.value)}
              variant='standard'
              value={formData.typeSelect || ''}
            />}
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={13} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box>
              {formError && <Error>{formError}</Error>}
              {formSuccess && <Message>{formSuccess}</Message>}
            </Box>
            <Box>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginRight: '10px' }}
              >
                Filter
              </MuiButton>
              <MuiButton
                onClick={() => onload()}
                type='button'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
              >
                Refresh
              </MuiButton>
            </Box>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
